import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from '@chatterbug/aaron'

const CertListSkeleton = ({ certItemsSection }) => {
  return <Grid gridGap="1x">{certItemsSection}</Grid>
}

CertListSkeleton.propTypes = {
  certItemsSection: PropTypes.any,
}

export default CertListSkeleton
